export default "__VITE_ASSET__C17Q7fCe__"